import React from "react";
import APP_CONSTANTS from "../shared/constants/app_constants";
import SingleSelectFieldEditor from '../KeenformEditor/components/FormElementEditors/SingleSelectFieldEditor';
import RadioSingleSelectFieldEditor from '../KeenformEditor/components/FormElementEditors/RadioSingleSelectFieldEditor';
import MultiSelectFieldEditor from '../KeenformEditor/components/FormElementEditors/MultiSelectFieldEditor';
import FilteringConditionalsEditor from './FilteringConditionalsEditor';

export default class FilteringRuleSection extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      filtered_options: props.form_rule.filtered_options
    }
  }

  deleteCondition = (index) => {
    this.props.deleteFilteringConditional(index);
  }

  renderPreview = () => {
    const filtered_options = this.props.target_attribute.options
    .filter(option => this.state.filtered_options.includes(option.uuid) === false);
    const componentProps = {
      ...this.props.target_attribute,
      options: filtered_options
    };
    switch(this.props.target_attribute.display_type){
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT:
        return (<SingleSelectFieldEditor {...componentProps} />);
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO:
        return (<RadioSingleSelectFieldEditor {...componentProps} />);
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX:
        return (<MultiSelectFieldEditor {...componentProps} />);
      default:
        console.error('we have invalid display type');
    }
  }

  renderStaticFiltering = () => {
    return (<React.Fragment>
      <div>
      {this.props.target_attribute.options.map(option => {
        const buttonTypeClass = (this.state.filtered_options.includes(option.uuid) ? 'btn-light' : 'btn-primary');
        return <button
          className={`btn ${buttonTypeClass}`}
          key={option.uuid}
          type='button'
          onClick={()=>{ this.toggleOption(option.uuid)}}>{option.label}</button>;
      })}
      <input 
        type='hidden'
        name={`form_rule[filtered_options][]`}
        value='' />
      {this.state.filtered_options.map((optionUUID, index) => {
        return <input 
          type='hidden'
          key={index}
          name={`form_rule[filtered_options][]`}
          value={optionUUID} />
      })}
    </div>
    <div>Preview:
      {this.renderPreview()}
    </div>
    </React.Fragment>);
  }

  toggleOption = (optionUUID) => {
    let filtered_options = [];
    if (this.state.filtered_options.includes(optionUUID)){
      filtered_options = this.state.filtered_options.filter(uuid => uuid !== optionUUID);
    } else {
      filtered_options = this.state.filtered_options.concat([optionUUID]);
    }
    this.setState({
      filtered_options: filtered_options
    });
  };
  
  render() {
    const form_rule = this.props.form_rule;
    return (<div>
      <h4><strong>Hide the following options:</strong></h4>
      <div>target attribute: {this.props.target_attribute.name}</div>
      <div>Static or Dynamic Filtering:</div>
      <div className="btn-group" role="group" aria-label="Basic example">
        <button 
          type="button"
          onClick={() => {this.props.updateAttributePerParams('dynamic_filtering', false)}}
          className={`btn ${form_rule.dynamic_filtering === false ? 'btn-primary' :'btn-light'}`}>Static</button>
        <button 
          type="button" 
          onClick={() => {this.props.updateAttributePerParams('dynamic_filtering', true)}}
          className={`btn ${form_rule.dynamic_filtering === true ? 'btn-primary' :'btn-light'}`}>Dynamic</button>
        <input 
          type="hidden"
          name="form_rule[dynamic_filtering]"
          value={!!this.props.form_rule.dynamic_filtering ? "1" : "0"} />
      </div>
      <div className="card">
        { this.props.form_rule.hasOwnProperty('dynamic_filtering') && this.props.form_rule.dynamic_filtering
          ? <FilteringConditionalsEditor 
              conditional_type="filtering_conditional"
              keenform={this.props.keenform}
              form_rule={form_rule}
              addNewCondition={this.props.addNewCondition}
              updateFormRuleAttributePerParams={this.props.updateFormRuleAttributePerParams}
              deleteConditional={this.props.deleteFilteringConditional} />
          : this.renderStaticFiltering()
        }
      </div>
    </div>);
  }
}